import React from 'react';
import PropTypes from 'prop-types';
import './Input.scss';

/**
 * Every input gets an accessible name: the visible label when one is given,
 * otherwise its placeholder (journey audit fix 23, Oct 2026).
 */
export default function Input({ label, id, placeholder, ...props }) {
  return (
    <div className="form-custom-input">
      {label && (
        <label htmlFor={id} className="form-custom-label">
          {label}
        </label>
      )}
      <input id={id} placeholder={placeholder} aria-label={label || placeholder} {...props} />
    </div>
  );
}

Input.propTypes = {
  label: PropTypes.string,
  id: PropTypes.string,
  placeholder: PropTypes.string,
};

Input.defaultProps = {
  label: undefined,
  id: undefined,
  placeholder: undefined,
};
